/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import {FormikProps} from 'formik'
import {KTSVG} from '../../../../../_metronic/helpers'
import {ModalAddUpdateEmail} from '../../../unit-consumer/components/ModalAddEditUnitConsumer/components/stepModal/components/ModalAddEditEmail'
import {ModalDeleteEmail} from '../../../unit-consumer/components/ModalAddEditUnitConsumer/components/stepModal/components/ModalDeleteEmail'
import useSocket from '../../../../hooks/useSocket'
import {
  getUnitConsumerVerificationCode,
  UnitConsumerVerificationCode,
} from '../../../../services/unitConsumerService'

type MonitoringFormValues = {
  username: string | null
  password: string | null
  provided_email_concessionarie: boolean
}

type Props = {
  concessionarie: any
  formik: FormikProps<MonitoringFormValues>
  unitConsumerId: string
  codeEmail: string | null
  dataEmails: any[]
  refresh: () => void
}

export function UnitConsumerMonitoringFields({
  concessionarie,
  formik,
  unitConsumerId,
  codeEmail,
  dataEmails,
  refresh,
}: Props) {
  const [showPassword, setShowPassword] = useState(false)
  const [copied, setCopied] = useState(false)
  const [showCreateAppModal, setShowCreateAppModal] = useState(false)
  const [showCreateAppModalDelete, setShowCreateAppModalDelete] = useState(false)
  const [myEmail, setMyEmail] = useState<any | null>(null)
  const [verification, setVerification] = useState<UnitConsumerVerificationCode | null>(null)
  const [codeCopied, setCodeCopied] = useState(false)
  const {socket, on, off} = useSocket()

  useEffect(() => {
    if (!unitConsumerId) return
    let active = true

    const load = () =>
      getUnitConsumerVerificationCode(unitConsumerId)
        .then((result) => {
          if (active) setVerification(result)
        })
        .catch((err) => console.error('Erro ao buscar código de verificação:', err))

    const handleNotice = (data: any) => {
      if (data && data.idUnitConsumer === unitConsumerId) load()
    }

    load()
    if (socket) on('verificationCode', handleNotice)

    return () => {
      active = false
      if (socket) off('verificationCode', handleNotice)
    }
  }, [unitConsumerId, socket])

  const handleCopyCode = () => {
    if (!verification || !verification.code) return
    navigator.clipboard
      .writeText(verification.code)
      .then(() => {
        setCodeCopied(true)
        setTimeout(() => setCodeCopied(false), 3000)
      })
      .catch((err) => console.error('Erro ao copiar:', err))
  }

  const handleCopyEmail = () => {
    const email = codeEmail
      ? `${codeEmail}@solarvision.email`
      : unitConsumerId
      ? `${unitConsumerId}@solarvision.email`
      : ''

    if (email) {
      navigator.clipboard
        .writeText(email)
        .then(() => {
          setCopied(true)
          setTimeout(() => setCopied(false), 3000)
        })
        .catch((err) => console.error('Erro ao copiar:', err))
    }
  }

  const handleCopyEmailApp = () => {
    const email = codeEmail
      ? `${codeEmail}@solarvisionapp.com`
      : unitConsumerId
      ? `${unitConsumerId}@solarvisionapp.com`
      : ''

    if (email) {
      navigator.clipboard
        .writeText(email)
        .then(() => {
          setCopied(true)
          setTimeout(() => setCopied(false), 3000)
        })
        .catch((err) => console.error('Erro ao copiar:', err))
    }
  }

  if (!concessionarie) return null

  return (
    <>
      <div style={{flex: '1'}}>
        <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
          {concessionarie.type_monitor === 'EMAIL' && (
            <li className='nav-item'>
              <span className='nav-link active text-active-primary border-active-primary border-hover-primary me-6'>
                Por e-mail
              </span>
            </li>
          )}
          {concessionarie.type_monitor === 'CREDENCIAIS' && (
            <li className='nav-item'>
              <span className='nav-link active text-active-primary border-active-primary border-hover-primary me-6'>
                Por credenciais
              </span>
            </li>
          )}
        </ul>

        <div className='tab-content'>
          {concessionarie.type_monitor === 'EMAIL' && (
            <div className='tab-pane fade active show' role='tabpanel'>
              <div className='border border-gray-300 border-dashed rounded p-5 mt-2 mb-5'>
                <h3 className='align-items-start flex-column mt-2' style={{display: 'flex', marginBottom: '2rem'}}>
                  <span className='card-label fw-bold fs-4 mb-1'>E-mail para vínculo à concessionária:</span>

                  <div style={{display: 'flex', gap: '1rem', flexWrap: 'wrap'}}>
                    <span
                      className='text-hover-primary text-gray-700 fs-5 mt-2 mb-2 cursor-pointer'
                      onClick={handleCopyEmail}
                    >
                      <i className='fas fa-envelope fs-7 me-2'></i>
                      {codeEmail
                        ? `${codeEmail}@solarvision.email`
                        : unitConsumerId
                        ? `${unitConsumerId}@solarvision.email`
                        : ''}
                    </span>

                    <span className='text-gray-400 fs-5 mt-2 mb-2'>ou</span>

                    <span
                      className='text-hover-primary text-gray-700 fs-5 mt-2 mb-2 cursor-pointer'
                      onClick={handleCopyEmailApp}
                    >
                      <i className='fas fa-envelope fs-7 me-2'></i>
                      {codeEmail
                        ? `${codeEmail}@solarvisionapp.com`
                        : unitConsumerId
                        ? `${unitConsumerId}@solarvisionapp.com`
                        : ''}
                    </span>
                  </div>

                  {copied && (
                    <div className='fv-plugins-message-container mb-2'>
                      <div className='fv-help-block text-success'>
                        Copiado para a área de transferência
                      </div>
                    </div>
                  )}

                  <span className='text-muted mt-1 fw-semibold fs-6'>
                    Adicione um de nossos e-mails no sistema da concessionária para receber as
                    faturas da unidade consumidora
                  </span>
                </h3>

                {verification && verification.code && (
                  <div className='notice d-flex bg-light-primary rounded border-primary border border-dashed p-4 mb-5'>
                    <div className='d-flex flex-column'>
                      <span className='fw-bold fs-6 text-gray-800'>
                        Último código de verificação
                        {verification.brand ? ` (${verification.brand})` : ''}
                      </span>
                      <span
                        className='fs-2 fw-bolder text-primary cursor-pointer mt-1'
                        onClick={handleCopyCode}
                      >
                        {verification.code}
                        <i className='fas fa-copy fs-6 ms-2'></i>
                      </span>
                      <span className='text-muted fs-7'>
                        {codeCopied
                          ? 'Copiado para a área de transferência'
                          : verification.receivedAt
                          ? `Recebido às ${new Date(verification.receivedAt).toLocaleTimeString('pt-BR')}`
                          : ''}
                      </span>
                    </div>
                  </div>
                )}

                <label className='d-flex align-items-center gap-2 fs-5 fw-semibold mb-2'>
                  <label className='form-check form-check-inline form-check-primary form-check-solid'>
                    <input
                      className='form-check-input bg-primary'
                      name='provided_email_concessionarie'
                      type='checkbox'
                      checked={formik.values.provided_email_concessionarie}
                      onChange={(e) =>
                        formik.setFieldValue('provided_email_concessionarie', e.target.checked)
                      }
                    />
                  </label>
                  <span>Confirmar vínculo do e-mail na concessionária.</span>
                </label>

                <div>
                  <h3 className='align-items-start flex-column mt-8' style={{display: 'flex', marginBottom: '0.7rem'}}>
                    <span className='card-label fw-bold fs-4'>
                      E-mail(s) para redirecionamento
                      <button
                        className='btn btn-sm text-hover-primary ms-2'
                        style={{padding: '0rem'}}
                        onClick={() => setShowCreateAppModal(true)}
                        type='button'
                      >
                        <KTSVG
                          className='svg-icon-muted svg-icon-2x'
                          path='/media/icons/duotune/general/gen035.svg'
                        />
                      </button>
                    </span>
                  </h3>

                  <div style={{height: '10rem'}} className='bg-light p-3'>
                    <div style={{height: '100%', width: '100%', overflow: 'auto'}}>
                      {dataEmails && dataEmails.length > 0 ? (
                        dataEmails.map((email: any) => (
                          <div
                            key={email.id}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                            }}
                          >
                            <span className='text-muted fw-semibold fs-6'>
                              {email.email ? email.email : ''}
                            </span>
                            <div>
                              <button
                                onClick={() => {
                                  setShowCreateAppModal(true)
                                  setMyEmail(email)
                                }}
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                type='button'
                              >
                                <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-4' />
                              </button>
                              <button
                                onClick={() => {
                                  setShowCreateAppModalDelete(true)
                                  setMyEmail(email)
                                }}
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                type='button'
                              >
                                <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-4' />
                              </button>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div
                          className='bg-light'
                          style={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '0.5rem',
                            flexDirection: 'column',
                          }}
                        >
                          <KTSVG path='/media/icons/duotune/general/gen004.svg' className='svg-icon-3x me-1' />
                          <h3 className='card-title d-flex align-items-center justify-content-center flex-column'>
                            <span className='text-muted fw-semibold fs-7'>Sem e-mails!</span>
                          </h3>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {concessionarie.type_monitor === 'CREDENCIAIS' && (
            <div className='tab-pane fade active show' role='tabpanel'>
              <div
                style={{display: 'flex', gap: '1rem'}}
                className='mt-2 mb-5 border border-gray-300 border-dashed rounded p-5'
              >
                <div className='fv-row flex-grow-1'>
                  <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                    <span>Usuário</span>
                  </label>
                  <input
                    type='text'
                    className='form-control form-control-lg form-control-solid'
                    name='username'
                    disabled={concessionarie.status_mon_aut !== 'NÃO MONITORADA' ? false : true}
                    value={formik.values.username || ''}
                    onChange={formik.handleChange}
                  />
                </div>

                <div className='fv-row flex-grow-1'>
                  <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                    <span>Senha</span>
                  </label>
                  <div style={{display: 'flex', gap: '0.2rem'}}>
                    <input
                      type={showPassword ? 'text' : 'password'}
                      className='form-control form-control-lg form-control-solid'
                      name='password'
                      disabled={concessionarie.status_mon_aut !== 'NÃO MONITORADA' ? false : true}
                      value={formik.values.password || ''}
                      onChange={formik.handleChange}
                    />
                    <a
                      onClick={() => setShowPassword(!showPassword)}
                      style={{height: 'auto'}}
                      href='#'
                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                    >
                      <i className='bi bi-eye-fill' style={{fontSize: '1.2rem'}}></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <ModalAddUpdateEmail
        show={showCreateAppModal}
        id={myEmail ? myEmail.id : undefined}
        data={myEmail ? myEmail : undefined}
        idUnitConsumer={unitConsumerId}
        handleClose={() => {
          setMyEmail(null)
          setShowCreateAppModal(false)
          refresh()
        }}
      />
      <ModalDeleteEmail
        show={showCreateAppModalDelete}
        data={myEmail}
        id={myEmail ? myEmail.id : undefined}
        handleClose={() => {
          setMyEmail(null)
          setShowCreateAppModalDelete(false)
          refresh()
        }}
      />
    </>
  )
}
